<template>
  <div class="guide-page-wrap">
    <guide-share-header :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :name="shareHaderName"></guide-share-header>
    <div class="guide-sections">
      <div v-for="(section, index) in config.sections" v-bind:key="index" class="single-section">
          <guide-head v-if="section.head" v-bind:title="section.head.title" v-bind:tips="section.head.tips"></guide-head>
          <guide-step v-for="(step, stepIndex) in section.steps" v-bind:key="stepIndex" v-bind:step="step" v-bind:index="stepIndex"></guide-step>
      </div>
    </div>
  </div>
</template>

<script>
import GuideHead from './GuideHead.vue';
import GuideStep from './GuideStep.vue';
import GuideShareHeader from './GuideShareHeader';

export default {
  name: 'GuidePage',
  props: ['config', 'wxaPage', 'wxaPageParam', 'shareHaderName'],
  components: {
    guideHead: GuideHead,
    guideStep: GuideStep,
    GuideShareHeader,
  },
};
</script>

<style lang="less">
.guide-sections {
  padding: 30px 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/component/GuidePage.vue